<script>
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import Customers from '@/services/Customers';
  import Cashless from '@/services/Cashless';
  import General from '@/services/General';
  import modalAddCustomer from '@/components/modals/customers/modalAddCustomer';
  import modalAddCustomerFromTicketing from '@/components/modals/customers/modalAddCustomerFromTicketing';
  import DatePicker from "vue2-datepicker";
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
  import _ from 'underscore';
  import CustomersMap from "@/components/widgets/customersMap";
  import Swal from "sweetalert2";


  export default {
  components: { Layout, PageHeader, modalAddCustomer, DatePicker, Multiselect, VueBootstrapTypeahead, CustomersMap, modalAddCustomerFromTicketing },
  page: {
      title: "Users",
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
  },
  watch: {

    'filterInput.first_name': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'firstname') }, 900),
    'filterInput.last_name': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'lastname')}, 900),
    'filterInput.email': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'email')}, 900),
    'filterInput.provider_ticketing_id': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'provider_ticketing_id')}, 900),
    'filterInput.address': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'address')}, 900),
    'filterInput.postal': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'postal')}, 900),
    'filterInput.city': _.debounce(function(search) { this.getCustomersAutocomplete(search, 'city')}, 900),

    'filterInput.ewallet_serial': _.debounce(function(search) { this.getCardsAutocomplete(search, 'ewallet_serial')}, 900),
  },
  data() {
    return {
        isAuthorized: false,
        error: null,
        filterData: false,
        showMapData: false,
        showMap: false,
        tableData: [],
        title: "Customers",
        items: [
          {
            text: "CRM",
            href: "/customers",
          },
          {
            text: "Users",
            active: true,
          },
        ],
        genderOptions: [
          { text: 'Male', value: 'M' },
          { text: 'Female', value: 'F' },
          { text: 'Other', value: 'O' },
          { text: 'None', value: '' },
        ],
        userAttributes: [
          { text: 'email_club', value: 'opt_in_email_club' },
          { text: 'email_partners', value: 'opt_in_email_partners' },
          { text: 'mail_club', value: 'opt_in_mail_club' },
          { text: 'phone_club', value: 'opt_in_phone_club' },
          { text: 'sms_club', value: 'opt_in_sms_club' }
        ],
        clickedDate:'',
        ticketing_client_types:[],
        userStatuses: [],
        triStateFilterOptions: [
          { text: 'All', value: '' },
          { text: 'With', value: 'Y' },
          { text: 'Without', value: 'N' },
        ],
        userTypeFilterOptions: [
          { text: 'All', value: '' },
          { text: 'Active Users', value: 'active' },
          { text: 'Potential Users', value: 'potential' },
        ],
        filterInput: {
          first_name: '',
          last_name: '',
          gender: [],
          email: '',
          birthdate: '',
          birthdates_temp: [],
          userStatus: [],
          attributes: [],
          created: '',
          address: '',
          city: '',
          postal: '',
          country: '',
          provider_ticketing_id:'',
          ewallet_serial:'',
          with_app: '',
          season_ticket:'',
          user_type: '',
        },
        customerData: [],
        countries: [],
        isBusy: false,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "created_on",
        sortDesc: true,
        fields: [
            {
              key: "first_name",
              label: "Customer",
              sortable: true,
            },
            {
              key: "email",
              label: "Email",
              sortable: true,
            },
            {
              key: "date_of_birth",
              label: "Birth Date",
              sortable: true,
            },
            {
              key: "gender",
              label: "Gender",
              sortable: true,
            },
            {
              key: "created_on",
              label: "Join Date",
              sortable: true,
            },
            {
              key: "status",
              label: "Status",
              sortable: true,
            },
            "action"
        ],
        createTicketingUsertBtn : false,
        exportLoading:false,
    };
  },
  computed: {
    attributeVals() {
      return this.filterInput.attributes.map(v => v.value);
    },
    countryVals() {
      return this.filterInput.country.map(v => v.alpha2code);
    },
  },
  async created() {
    this.createTicketingUsertBtn = await this.checkObjectAccessCall('button.customers.CreateUserFromTicketing');

    this.getUserStatuses()
    this.getCountry()
  },
  methods: {
      /**
     * Search the table data with search input
     */
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },


    async getCustomersAutocomplete(query, inputTypeName) {
      this.customerData = [];

      if (query.trim().length > 0) {
        let column = '';
        let limit = 1000;
        let table = '';
        let select = [];

        if (inputTypeName === 'firstname') {
          column = 'first_name';
          table = 'crm_user';
          select = ['first_name'];
        }
        else if (inputTypeName === 'lastname') {
          column = 'last_name';
          table = 'crm_user';
          select = ['last_name'];
        }
        else if (inputTypeName === 'email') {
          column = 'email';
          table = 'crm_user';
          select = ['email'];
        }
        else if (inputTypeName === 'provider_ticketing_id') {
          column = 'CustomerNumber';
          table = 'crm_tymes4';
          select = ['CustomerNumber'];
        }
        else if (inputTypeName === 'address') {
          column = 'line1';
          table = 'crm_address';
          select = ['line1'];
        }
        else if (inputTypeName === 'city') {
          column = 'city';
          table = 'crm_address';
          select = ['city'];
        }
        else if (inputTypeName === 'postal') {
          column = 'zip';
          table = 'crm_address';
          select = ['zip'];
        }

        const payload = {
          table,
          column,
          filter: query,
          limit,
          select
        };

        try {
          const response = await General.autocomplete(payload);

          const rawData = Array.isArray(response.data.data) ? response.data.data : [];

          const suggestions = rawData.map(item => {
            if (column === 'first_name') return { text: item.first_name };
            if (column === 'last_name') return { text: item.last_name };
            if (column === 'email') return { text: item.email };

            if (column === 'line1') return {
              text: item.line1,
              details: `${item.line1 || ''}`.trim()
            };
            if (column === 'CustomerNumber') return {
              text: item.CustomerNumber,
              details: `${item.CustomerNumber || ''}`.trim()
            };
            if (column === 'city') return {
              text: item.city,
              details: `${item.city || ''}`.trim()
            };
            if (column === 'zip') return {
              text: item.zip,
              details: `${item.zip || ''}`.trim()
            };
            return null;
          }).filter(Boolean);

          // remove duplicates
          this.customerData = suggestions.filter(
                  (v, i, a) => a.findIndex(t => t.text === v.text) === i
          );

        } catch (err) {
          console.error(err);
        }
      }
    },

      async getCardsAutocomplete(query, inputTypeName) {
        this.customerData = []

        if(query.trim().length > 0){
          if(inputTypeName === 'ewallet_serial'){
            query = 'serial='+query
          }
          const response = await Cashless.getCards(query)
          const rawData = await response
          var suggestions = [];
          rawData.data.data.forEach(function (item) {
            if(item.serial && inputTypeName === 'ewallet_serial'){
              suggestions.push({text:item.serial});
            }
          });

          this.customerData = suggestions.filter((value, index, self) => self.map(x => x.text).indexOf(value.text) == index)
        }
      },

      async getCustomers(){
          this.currentPage = 1;
          try {
            this.filterData = true;
            this.toggleBusy();
            var filters = this.getFilters()
            const response = await Customers.getCustomersByFilter(filters)
            this.tableData = response.data.data
            this.totalRows = this.tableData.length
          } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.tableData = []
            this.totalRows = 0;
          } finally {
            this.toggleBusy();
            // Scroll to results after data is loaded and busy state is cleared
            this.$nextTick(() => {
              setTimeout(() => {
                this.scrollToResults();
              }, 150);
            });
          }
        },

        scrollToResults() {
          const resultsElement = this.$refs.resultsCard;
          if (resultsElement) {
            // Calculate offset to account for any fixed headers
            const offset = 80;
            const elementPosition = resultsElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        },

        modalAddCustomer(){
          this.$bvModal.show("add_new_customer");
        },

        modalAddCustomerFromTicketing(){
          this.$bvModal.show("add_new_customer_from_ticketing");
        },

        getFilters(){
          const encode = (value) => encodeURIComponent(value);

          var filter_string = '&limit=10000';
          filter_string += (this.filterInput.first_name) ? '&first_name='+encode(this.filterInput.first_name) : "";
          filter_string += (this.filterInput.last_name) ? '&last_name='+encode(this.filterInput.last_name) : "";
          filter_string += (this.filterInput.gender.length) ? '&gender='+encode(this.filterInput.gender) : "";
          filter_string += (this.filterInput.email) ? '&email='+encode(this.filterInput.email) : "";

          if(this.filterInput.birthdate.length == 2){
            filter_string += (this.filterInput.birthdate[0]) ? '&birthdate_s='+encode(moment(this.filterInput.birthdate[0]).format('YYYY-MM-DD')) : "";
            filter_string += (this.filterInput.birthdate[1]) ? '&birthdate_e='+encode(moment(this.filterInput.birthdate[1]).format('YYYY-MM-DD')) : "";
          }

          if(this.filterInput.created.length == 2){
            filter_string += (this.filterInput.created[0]) ? '&created_s='+encode(moment(this.filterInput.created[0]).format('YYYY-MM-DD')) : "";
            filter_string += (this.filterInput.created[1]) ? '&created_e='+encode(moment(this.filterInput.created[1]).format('YYYY-MM-DD')) : "";
          }

          filter_string += (this.filterInput.userStatus.length) ? '&user_status='+encode(JSON.stringify(this.filterInput.userStatus)) : "";
          filter_string += (this.filterInput.attributes.length) ? '&attributes='+encode(JSON.stringify(this.attributeVals)) : "";

          filter_string += (this.filterInput.address) ? '&address='+encode(this.filterInput.address) : "";
          filter_string += (this.filterInput.postal) ? '&postal='+encode(this.filterInput.postal) : "";
          filter_string += (this.filterInput.city) ? '&city='+encode(this.filterInput.city) : "";

          filter_string += (this.filterInput.country.length) ? '&country='+encode(JSON.stringify(this.countryVals)) : "";

          filter_string += (this.filterInput.provider_ticketing_id) ? '&provider_ticketing_id='+encode(this.filterInput.provider_ticketing_id) : "";
          filter_string += (this.filterInput.ewallet_serial) ? '&ewallet_serial='+encode(this.filterInput.ewallet_serial) : "";

          filter_string += (this.filterInput.with_app) ? '&with_app='+encode(this.filterInput.with_app) : "";
          filter_string += (this.filterInput.season_ticket) ? '&season_ticket='+encode(this.filterInput.season_ticket) : "";
          filter_string += (this.filterInput.user_type) ? '&user_type='+encode(this.filterInput.user_type) : "";

          return filter_string = filter_string.substring(1);
        },

        async getUserStatuses(){
          try {
            await Customers.getUserStatuses({

            }).then((response) => {
              var statuses = [];
              response.data.forEach(function (item) {
                if(item.status){
                  statuses.push(item.status);
                }
              });
              this.userStatuses = statuses;
            }).catch(error => {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.failedmsg(this.error)
            }).finally(() => {
            })

          } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.failedmsg(this.error)
          }
        },

        async getCountry() {
          try {
            await General.getCountry({
            }).then((response) => {
              this.countries = this.preferredCountryOrder(response.data, 'name');
            }).catch(error => {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error)
            })

          } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.failedmsg(this.error)
          }
        },

        async showCustomerMapData(){
          this.showMapData = !this.showMapData

          if(this.showMapData){
            this.showMap = true;
          }

        },

        handleDatePickerConfirm(dateRange){
          if (!dateRange[0]) {
            // If dateRange is not set birthdate should be the last clicked date
            this.filterInput.birthdate = [this.clickedDate, this.clickedDate];
          }
        },

        handleDatePickerConfirm2(dateRange){
          this.clickedDate = dateRange
        },

        handleDatePickerConfirm3(){
          this.filterInput.birthdate = []
        },
        async fullCRMExport(){
          this.exportLoading = true;
          const params = 'exportAsCsv=1'

          try {
            const response = await Customers.fullCRMExport(params);

            if(response.status === 200){
                Swal.fire(
                   'Export Success',
                   'CRM Users Successfully Exported',
                   'success'
               );
               this.exportLoading = false;
            }

            if (response.status === 204) {
              this.failedmsg('No customer data available');
              this.exportLoading = false;
              return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download','full_crm_export.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

          }catch(error){
            this.error = error.response.data.error ? error.response.data.error : "An Error occurred please try again later";
            this.failedmsg(this.error)
            this.exportLoading = false;
          }
        }
      },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mt-4">
              <div class="col-md-12">
                <div class="mb-3">
                  <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                     @click="modalAddCustomer">
                    <i class="mdi mdi-plus me-2"></i>
                    Create New
                  </a>


                  <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                      v-if="createTicketingUsertBtn"
                      @click="modalAddCustomerFromTicketing">
                    <i class="mdi mdi-plus me-2"></i>
                    Create User From Ticketing
                  </a>

                  <a :class="{'ms-3': createTicketingUsertBtn }" v-if="menuToArray.includes('button.crm_users.full_export')" title="Export All CRM Users" href="javascript:void(0);" class="btn btn-primary waves-effect waves-light me-3"
                     @click="fullCRMExport">
                    <i class="mdi mdi-file-export-outline me-2"></i>
                    Full Export
                    <b-spinner class="ms-2" v-show="exportLoading" small></b-spinner>
                  </a>
                </div>
              </div>
              <div class="col-md-12">
                <div class="custom-accordion">
                  <a
                          class="text-body fw-semibold pb-2 d-block"
                          data-toggle="collapse"
                          href="javascript: void(0);"
                          role="button"
                          aria-expanded="false"
                          v-b-toggle.categories-collapse
                  >
                    <i class="mdi mdi-chevron-up accor-down-icon text-primary me-1"></i>Filters
                  </a>
                  <b-collapse visible id="categories-collapse">
                    <div class="card p-2 border shadow-none">
                      <div class="row">
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="First name" label-for="formrow-firstname-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-firstname-input" ref="first_nameAutocomplete"
                                    v-model.trim="filterInput.first_name"
                                    :data=customerData
                                    :serializer="s => s.text"/>
                          </b-form-group>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Last name" label-for="formrow-lastname-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-lastname-input" ref="last_nameAutocomplete"
                                     v-model.trim="filterInput.last_name"
                                     :data=customerData
                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Gender" class="mb-3" style="font-weight: 500;">
                            <b-form-checkbox-group name="gender" :options="genderOptions"
                                                   v-model="filterInput.gender"></b-form-checkbox-group>
                          </b-form-group>

                        </div>
                        <div class="col-sm-12 col-md-3 ">
                          <b-form-group label="User Attributes" label-for="formrow-attributes-input" class="mb-3">
                            <multiselect
                                    v-model="filterInput.attributes"
                                    :options="userAttributes"
                                    :multiple="true"
                                    label="text"
                                    track-by="value"
                            ></multiselect>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 col-md-3">
                          <div class="form-group mb-3">
                            <b-form-group label="Email" label-for="formrow-email-input" class="mb-3">
                              <vue-bootstrap-typeahead id="formrow-email-input" ref="emailAutocomplete"
                                                       v-model.trim="filterInput.email"
                                                       :data=customerData
                                                       :serializer="s => s.text"/>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <div class="form-group mb-3">

                            <b-form-group label="Phone" label-for="formrow-phone-input" class="mb-3">
                              <vue-bootstrap-typeahead id="formrow-phone-input" ref="phoneAutocomplete"
                                                       v-model.trim="filterInput.phone"
                                                       :data=customerData
                                                       :serializer="s => s.text"/>
                            </b-form-group>

                          </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Birthdate" label-for="formrow-birthdate-input" class="mb-3">
                            <date-picker
                                    v-model="filterInput.birthdate"
                                    range
                                    append-to-body
                                    lang="en"
                                    confirm
                                    @pick="handleDatePickerConfirm2"
                                    @confirm="handleDatePickerConfirm"
                                    @open="handleDatePickerConfirm3"
                                    format="DD/MM/YYYY"
                            ></date-picker>
                          </b-form-group>

                        </div>
                        <div class="col-sm-12 col-md-3">
                          <div class="form-group mb-3">
                            <b-form-group label="Created" label-for="formrow-created-input" class="mb-3">
                              <date-picker
                                      v-model="filterInput.created"
                                      range
                                      append-to-body
                                      lang="en"
                                      confirm
                                      format="DD/MM/YYYY"
                              ></date-picker>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Street Address" label-for="formrow-address-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-address-input" ref="addressAutocomplete"
                                                     v-model.trim="filterInput.address"
                                                     :data=customerData
                                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Postal Code" label-for="formrow-postal-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-postal-input" ref="postalAutocomplete"
                                                     v-model.trim="filterInput.postal"
                                                     :data=customerData
                                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="City" label-for="formrow-city-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-city-input" ref="cityAutocomplete"
                                                     v-model.trim="filterInput.city"
                                                     :data=customerData
                                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>
                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Country" label-for="formrow-country-input" class="mb-3">
                            <multiselect
                                    v-model="filterInput.country"
                                    :options="countries"
                                    :multiple="true"
                                    label="name"
                                    track-by="alpha2code"
                                    value="name"
                            ></multiselect>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row">

                        <div class="col-sm-12 col-md-3" v-if="checkObjectAccess('ticketing')">
                          <b-form-group label="Ticketing Customer Number" label-for="formrow-provider_ticketing_id-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-provider_ticketing_id-input" ref="provider_ticketing_idAutocomplete"
                                                     v-model.trim="filterInput.provider_ticketing_id"
                                                     :data=customerData
                                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>

                        <div class="col-sm-12 col-md-3" v-if="checkObjectAccess('cashless')">
                          <b-form-group label="Card Serial Number" label-for="formrow-card_serial_number-input" class="mb-3">
                            <vue-bootstrap-typeahead id="formrow-card_serial_number-input" ref="ewallet_serialAutocomplete"
                                                     v-model.trim="filterInput.ewallet_serial"
                                                     :data=customerData
                                                     :serializer="s => s.text"/>
                          </b-form-group>
                        </div>

                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="User Status" label-for="formrow-userstatus-input" class="mb-3">
                          <multiselect
                                  v-model="filterInput.userStatus"
                                  :options="userStatuses"
                                  :multiple="true"
                          ></multiselect>
                          </b-form-group>
                        </div>

                        <div class="col-sm-12 col-md-3" v-if="checkObjectAccess('ticketing')">
                          <b-form-group label="Season Holder" label-for="formrow-season-ticket-input" class="mb-3">
                            <b-form-radio-group
                              id="formrow-season-ticket-input"
                              v-model="filterInput.season_ticket"
                              :options="triStateFilterOptions"
                              name="season_ticket"
                            />
                          </b-form-group>
                        </div>

                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="Users" label-for="formrow-user-type-input" class="mb-3">
                            <b-form-radio-group
                              id="formrow-user-type-input"
                              v-model="filterInput.user_type"
                              :options="userTypeFilterOptions"
                              name="user_type"
                            />
                          </b-form-group>
                        </div>

                        <div class="col-sm-12 col-md-3">
                          <b-form-group label="With App" label-for="formrow-with-app-input" class="mb-3">
                            <b-form-radio-group
                              id="formrow-with-app-input"
                              v-model="filterInput.with_app"
                              :options="triStateFilterOptions"
                              name="with_app"
                            />
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col d-inline-flex">
                          <button type="button" class="btn btn-success me-2 w-lg" @click="getCustomers">Filter</button>
                          <button type="button" class="btn btn-primary w-lg" @click="resetFilters">Reset</button>
                        </div>
                      </div>

                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="card" v-show="showMapData">
          <div class="card-body">
            <div class="row">
              <div class="col mb-3">
                <strong class="font-size-18">User Map Data</strong>
                <a href="javascript:void(0);" class="card-title float-end" @click="showMapData = !showMapData">X</a>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                  <CustomersMap :customerData="this.tableData" :showMapBool="this.showMap" />
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-show="filterData" ref="resultsCard">
          <div class="card-body">

            <div class="row mt-4">
              <div class="col d-inline-flex align-items-center" >
                <h4 class="card-title m-0">Total Users: {{totalRows}}</h4>
                <button type="button" class="btn btn-primary mx-5 w-sm" @click="showCustomerMapData"><i class="uil uil-map-marker-alt font-size-18"></i> Show Map</button>
              </div>
            </div>

            <div class="row mt-4" v-show="filterData">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-show="filterData">
              <b-table
                      :items="tableData"
                      :busy="isBusy"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      show-empty
                      empty-text="No Data Found"
              >

                <template v-slot:cell(first_name)="data">
                  {{ data.item.first_name + ' ' + data.item.middle_name + ' ' +  data.item.last_name }}
                </template>

                <template v-slot:cell(email)="data">
                    {{ data.item.email }}
                </template>

                <template v-slot:cell(status)="data">
                  <div class="font-size-16" v-html="format_status(data.item.status)"></div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <router-link title="View Customer" :to="{ path: `/customers/profile/${data.item.customer_id}`}">
                        <i class="uil uil-eye font-size-18"></i>
                      </router-link>
                    </li>
                  </ul>
                </template>

              </b-table>
            </div>
            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- MODALS -->
    <modalAddCustomer @onRefresh="getCustomers()"></modalAddCustomer>
    <modalAddCustomerFromTicketing ></modalAddCustomerFromTicketing>
    <!-- /MODALS -->

  </Layout>
</template>
